import request from '@/utils/requestThingsBoard'

/** save Tenant */
// TODO: fix parameters
export function queryDeviceData(params) {
  return request({
    url: '/device/data',
    method: 'post',
    data: params
  })
}

export function queryAssetData(params, pid) {
  return request({
    // url: '/asset/data',
    url: '/project/asset/data/' + pid,
    method: 'post',
    data: params
  })
}

export function queryAssetDataAndPrice(params, pid) {
  return request({
    // url: '/asset/dataAndPrice',
    url: '/project/asset/dataAndPrice/' + pid,
    method: 'post',
    data: params
  })
}

export function queryAssetTimeSharingData(params) {
  return request({
    url: '/asset/dataBySharing',
    method: 'post',
    data: params
  })
}

export function queryenergyByTimeSharing(params, pid) {
  return request({
    // url: '/asset/energyByTimeSharing',
    url: '/project/asset/energyByTimeSharing/' + pid,
    method: 'post',
    data: params
  })
}

export function queryVirtualData(params, pid) {
  return request({
    // url: '/virtual/data',
    url: '/project/virtual/data/' + pid,
    method: 'post',
    data: params
  })
}

export function queryRealTimeData(params) {
  return request({
    url: '/device/realTime',
    method: 'post',
    data: params
  })
}
